module.exports = __webpack_public_path__ + "static/SyedHamzaResume-bc0152eede78291ce9269b8219b6c909.pdf";